module.exports = __webpack_public_path__ + "static/media/cert_59.ed43746a.jpg";